export default {
    data() {
        return {
            navigationIsVisble: false,
        };
    },

    watch: {
        navigationIsVisble: function () {
            document.getElementsByTagName('body')[0].classList.toggle("noscroll");
            document.getElementsByTagName('body')[0].classList.toggle("navigation-visible");

            if (document.getElementsByTagName('header')[0].classList.contains('fixed')) {
                document.getElementsByTagName('header')[0].classList.toggle("shadow-lg");
            }
        },
    }
};
